import { Box, BoxProps } from "@chakra-ui/react"
import React from "react"

export const ContentWrapper: React.FC<BoxProps> = ({children, ...props}) => {
  return (
    <Box maxW={{ base: "28rem", md: "42rem", lg: "66rem", xl: "82rem" }} margin="0 auto" paddingX={{lg: "200", md: "80", base: "24"}} {...props}>{children}</Box>
  )
}
